var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcInclusaoPedido = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#2ABA83;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#2ABA83;}\r\n\t.st2{fill:#D4145A;}\r\n\t.st3{fill:#363636;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;}\r\n\t.st6{fill:#30323A;}\r\n\t.st7{font-family:'Poppins-Regular';}\r\n\t.st8{font-size:3.9346px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bolsas_e_Olheiras"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Hidratante"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Repelente"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guias"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Barba"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calv\\xEDcie"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Clareador"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beleza"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Iluminador"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Preechedor"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Crescimento_Capilar"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Pesco\\xE7o_e_Colo"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Cabelo"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Sa\\xFAde"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Unha"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Protetor_Solar"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Texto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.5,24.96c-0.15-0.23-0.46-0.3-0.69-0.16L33,26.57V22.7c0-0.28-0.22-0.5-0.5-0.5S32,22.42,32,22.7v3.87 l-2.81-1.76c-0.23-0.15-0.54-0.08-0.69,0.16c-0.15,0.23-0.08,0.54,0.16,0.69l3.57,2.25c0,0,0.01,0,0.01,0 c0.08,0.04,0.16,0.07,0.25,0.07c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0.08,0,0.16-0.02,0.24-0.06c0,0,0.01-0.01,0.01-0.01 c0,0,0.01,0,0.01,0l3.57-2.25C36.58,25.5,36.65,25.19,36.5,24.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.23,20.25H43.8c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h2.42c0.62,0,1.12,0.5,1.12,1.12v19.01 c0,0.62-0.5,1.12-1.12,1.12H18.34c-0.62,0-1.12-0.5-1.12-1.12V22.36c0-0.62,0.5-1.12,1.12-1.12h22.8c0.28,0,0.5-0.22,0.5-0.5 s-0.22-0.5-0.5-0.5h-22.8c-1.17,0-2.12,0.95-2.12,2.12v19.01c0,1.17,0.95,2.12,2.12,2.12h8.22v2.83h-7.08 c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5H43.8c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-6.2v-2.83h8.62 c1.17,0,2.12-0.95,2.12-2.12V22.36C48.34,21.2,47.39,20.25,46.23,20.25z M36.61,46.32h-9.04v-2.83h9.04V46.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.36,29.96v9.21c0,0.64,0.52,1.16,1.16,1.16h19.64c0.64,0,1.16-0.52,1.16-1.16v-9.21c0-0.64-0.52-1.16-1.16-1.16H22.52 C21.88,28.8,21.36,29.32,21.36,29.96z M42.32,29.96v9.21c0,0.09-0.07,0.16-0.16,0.16H22.52c-0.09,0-0.16-0.07-0.16-0.16v-9.21 c0-0.09,0.07-0.16,0.16-0.16h19.64C42.25,29.8,42.32,29.87,42.32,29.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.19,34.06h-9.95c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h9.95c0.28,0,0.5-0.22,0.5-0.5S35.47,34.06,35.19,34.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43,34.06h-2.27c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h2.27c0.28,0,0.5-0.22,0.5-0.5S39.7,34.06,39.43,34.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.19,37.9h9.95c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-9.95c-0.28,0-0.5,0.22-0.5,0.5S24.92,37.9,25.19,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,37.9h2.27c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-2.27c-0.28,0-0.5,0.22-0.5,0.5S36.83,37.9,37.11,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.19,32.37h9.95c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-9.95c-0.28,0-0.5,0.22-0.5,0.5S24.92,32.37,25.19,32.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,32.37h2.27c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-2.27c-0.28,0-0.5,0.22-0.5,0.5S36.83,32.37,37.11,32.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "label",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 11.9986 58.6176)",
    className: "st6 st7 st8"
  }, "INCLUS\xC3O DE PEDIDO"))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcInclusaoPedido, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-inclusao-pedido.5fca3f89.svg";
export { ForwardRef as ReactComponent };